import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';
import {AuthService} from "../../../service/auth.service";
import {UserContextService} from "../../../service/context/user-context.service";
import {PermissionContextService} from "../../../service/context/permission-context.service";
import {SecurityService} from "../../../service/security.service";
import {map, switchMap, tap} from "rxjs";
import {UserService} from "../../../feature/settings/users/service/user.service";

export const authGuard: CanActivateFn = (route, state) => {
  const oauthService = inject(OAuthService);
  const router = inject(Router);
  const authService = inject(AuthService);
  const userService = inject(UserService);
  const securityService = inject(SecurityService);
  const permissionContext = inject(PermissionContextService);
  const userContext = inject(UserContextService);

  if (!oauthService.hasValidAccessToken()) {
    authService.setRedirectUrl(state.url);
    return router.createUrlTree(['/login']);
  }

  return securityService.getAllMyPermissions().pipe(
    tap(permissions => {
      permissionContext.set(permissions.map(value => value.permission).flat());
    }),
    switchMap(() => userService.getUser()),
    tap(user => {
      userContext.setUser(user);
      userContext.updateUserPrimaryLocation(user.activeLocation);
      // userContext.setUserPrimaryLocation(user.activeLocation);
      const isHeadquarterUser = user.userLocations?.some(loc => loc.isHeadquarter) ?? false;
      userContext.setInitialHeadquarterStatus(isHeadquarterUser);
    }),
    map(() => true)
  );

};
